import React, { createContext, useContext } from 'react'
import { useBaseNavItems } from './useNavItems'
import type { NavItemConfig } from './types'

interface NavItemsContextValue {
  navItems: NavItemConfig[]
  isLoading: boolean
}

const NavItemsContext = createContext<NavItemsContextValue | null>(null)

export function NavItemsProvider({ children }: { children: React.ReactNode }) {
  const value = useBaseNavItems()

  return (
    <NavItemsContext.Provider value={value}>
      {children}
    </NavItemsContext.Provider>
  )
}

export function useNavItems(): NavItemsContextValue {
  const ctx = useContext(NavItemsContext)
  if (!ctx) {
    throw new Error('useNavItems must be used within a NavItemsProvider')
  }
  return ctx
}
